<template>
  <Dialog
    width="400px"
    :visible="visible"
    @close="handleClose"
  >
    <div class="stopday-tips">
      注意：默认停投天数为大于等于5天，您可以自定义停投天数，范围在1-60天
    </div>
    <span class="stopday-label">停投天数：</span>
    <InputNumber
      :min="1"
      :max="60"
      :precision="0"
      v-model="day"
      size="mini"
    />
    <span slot="footer">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" @click="handleConfirm">确定</Button>
    </span>
  </Dialog>
</template>

<script>
import { Dialog, InputNumber, Button } from 'element-ui';

export default {
  components: {
    Dialog,
    InputNumber,
    Button
  },

  props: {
    // 是否显示停投天数对话框
    visible: {
      type: Boolean,
    },

    // 停投天数
    // 默认5天
    value: {
      type: Number,
      required: true,
      default: 5,
    }
  },

  model: {
    prop: 'value',
    event: 'confirm',
  },

  data() {
    return {
      day: this.value,
    };
  },

  methods: {
    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false);
    },

    // 点击取消
    handleCancel() {
      this.handleClose();
    },

    // 点击确认
    handleConfirm() {
      this.$emit('confirm', this.day);
      this.handleClose();
    }
  }
};
</script>

<style lang="less" scoped>
.stopday {
  &-tips {
    color: #909399;
    margin-bottom: 20px;
  }

  &-label {
    margin-right: 10px
  }
}
</style>
